import { render, staticRenderFns } from "./PicPay.vue?vue&type=template&id=48e74d1f&scoped=true"
import script from "./PicPay.vue?vue&type=script&lang=ts"
export * from "./PicPay.vue?vue&type=script&lang=ts"
import style0 from "./PicPay.vue?vue&type=style&index=0&id=48e74d1f&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e74d1f",
  null
  
)

export default component.exports